// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Axios Imports
import axios from "axios";

export let isLoadingData = true;

export const getUsers = createAsyncThunk(
  "appUsers/getUsers",
  async (params) => {
    isLoadingData = true;
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_API_URL}/api/account/getAllUsers`,
      params
    );
    isLoadingData = false;
    return {
      params,
      data: response.data.users,
      allData: response.data.users,
      totalPages: response.data.total,
    };
  }
);

export const deleteUser = createAsyncThunk(
  "appUsers/deleteUser",
  async (id, { dispatch, getState }) => {
    await axios.delete("/apps/invoice/delete", { id });
    await dispatch(getData(getState().invoice.params));
    return id;
  }
);

export const appUsersSlice = createSlice({
  name: "appUsers",
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.allData = action.payload.data;
      state.total = action.payload.totalPages;
      state.params = action.payload.params;
    });
  },
});

export default appUsersSlice.reducer;
